import React, { useState, useEffect } from 'react'
import { Button, Container, Card, Row, Col, Form } from 'react-bootstrap'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { 
  FaArrowLeft, 
  FaUser, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaIdCard,
  FaUsers,
  FaVenusMars
} from 'react-icons/fa'
import { 
  BsPersonBadge,
  BsCalendar3,
  BsBuilding,
  BsFileEarmarkText,
  BsChevronDown,
  BsChevronUp,
  BsPencilFill
} from 'react-icons/bs'
import toast from 'react-hot-toast'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useSidebar } from './SidebarContext'
import { useAuth } from './AuthContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { LuGraduationCap } from 'react-icons/lu'

const UpdateStudentProfile = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])
  
  // Section visibility states
  const [showPersonalInfo, setShowPersonalInfo] = useState(true)
  const [showParentInfo, setShowParentInfo] = useState(false)

  const { student_id } = useParams()
  console.log('Student ID:', student_id)

  const location = useLocation()
  const enquiryData = location.state?.enquiry || location.state?.data
  console.log('Enquiry Data:', enquiryData)
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    ...enquiryData,

    // student_id: student_id,
  })
  const [studentImage, setStudentImage] = useState(null)
  // const [courseTouched, setCourseTouched] = useState(false)
  // const [countColor, setCountColor] = useState('') // Add color for the response
  // const [errors, setErrors] = useState({})

  const [institutes, setInstitutes] = useState([])

  // const [courses, setCourses] = useState([])
  // const [classes, setClasses] = useState([])
  // const [studentCount, setStudentCount] = useState(null)

  // const [selectedNewCourse, setSelectedNewCourse] = useState([])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = response.data.data
        const matchedStudent = students.find(
          (std) => std.id === Number(student_id),
        )
        if (matchedStudent) {
          setFormData({
            ...matchedStudent,
            course_id: matchedStudent.course_id,
            class_id: matchedStudent.class_id,
          })
        } else {
          console.error('Student not found')
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    if (student_id) {
      fetchFilteredData()
    }
  }, [student_id])

  useEffect(() => {
    if (enquiryData) {
      setFormData(enquiryData)
    }
  }, [enquiryData])

  // useEffect(() => {
  //   ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
  //   ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  // }, [])
  useEffect(() => {
    ApiEndpoints.getAllInstitutes().then((res) => {
      if (Array.isArray(res.data.data)) {
        setInstitutes(res.data.data)
      } else {
        setInstitutes([]) // Fallback to empty array
      }
    })
  }, [])

  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  const handleBack = () => {
    navigate('/students')
  }

  const handleSaveAsStudent = async (e) => {
    e.preventDefault()
    // const newErrors = {}

    // if (!formData.course_id) newErrors.course_id = true
    // if (!formData.class_id) newErrors.class_id = true

    // if (Object.keys(newErrors).length) {
    //   setErrors(newErrors)
    //   toast.error('Please fill required fields.')
    //   return
    // }

    try {
      let imageUrl = null
      if (studentImage) {
        if (studentImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }
        const formData = new FormData()
        formData.append('image', studentImage)
        formData.append('folder', 'student')
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value)
        }
        const imageResponse = await axios.post(
          BASE_URL+'/upload-image',
          formData,
        )
        imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        console.log('IMGURL', imageUrl)
      }
      const payload = {
        // ...updatedStudent,
        ...formData,
        student_image: imageUrl,
        enquiry_id: enquiryData ? enquiryData?.id : student_id,
      }
      console.log('Sending data: ', payload)
      console.log('Student ID in payload:', payload.id)

      const response = await ApiEndpoints.editStudent(payload.id, payload)
      toast.success(response.data.message)
      navigate('/students')
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  // useEffect(() => {
  //   setSelectedNewCourse(formData.course_id)
  // }, [])

  // const shouldDisableCourseAndClass =
  //   formData.course_id !== null &&
  //   formData.course_id !== '' &&
  //   formData.class_id !== null &&
  //   formData.class_id !== ''

  // const handleCourseChange = (e) => {
  //   const courseId = e.target.value
  //   setFormData((prev) => ({ ...prev, course_id: courseId }))

  //   console.log('Selected course Id:', courseId)
  //   setCourseTouched(true)
  //   setSelectedNewCourse(courseId)
  //   setStudentCount(null)
  //   console.log('Cleared Classes')

  //   if (courseId) {
  //     ApiEndpoints.getAllClassesByCourseId(courseId)
  //       .then((res) => {
  //         const { data } = res
  //         if (data.status === false || !data.data?.length) {
  //           // toast.error('No classes found for this course.')
  //           setClasses([])
  //           setStudentCount(null)
  //         } else {
  //           setClasses(data.data)
  //           // setFormData(data.data)
  //         }
  //       })
  //       .catch((error) => {
  //         // This is where 404 or other errors come
  //         if (
  //           error.response?.data?.message === 'No classes found for this course'
  //         ) {
  //           // toast.error('No classes found for this course.')
  //         } else {
  //           console.error('Error fetching classes:', error)
  //           // toast.error('Something went wrong while fetching classes.')
  //         }
  //         setClasses([])
  //       })
  //   }
  // }

  // const handleClassChange = (e) => {
  //   const classId = e.target.value
  //   setFormData((prev) => ({ ...prev, class_id: classId }))

  //   // Clear previous student count
  //   setStudentCount(null)
  //   setCountColor('')

  //   if (classId) {
  //     // Call the API to get the student count for the selected class
  //     fetch(
  //       BASE_URL+`/get/class/student/count?class_id=${classId}`,
  //     )
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (
  //           data?.status &&
  //           data?.data?.current !== undefined &&
  //           data?.data?.maximum_limit !== undefined
  //         ) {
  //           const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
  //           const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
  //           setStudentCount({ current, maximum_limit }) // Set the state with correct property names
  //           setCountColor('green') // Example color for success
  //         } else {
  //           setStudentCount('No data available')
  //           setCountColor('red') // Example color for no data
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error fetching student count:', error)
  //         setStudentCount('Error fetching data')
  //         setCountColor('red') // Example color for error
  //       })
  //   }
  // }

  // const handleNavigateToCreateClass = () => {
  //   navigate('/AddClass')
  // }
  return (
    <>
      <style>
        {`
          .info-label {
            font-size: 12px;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 6px;
            font-family: 'Inter', system-ui, sans-serif;
          }
          .info-value {
            font-size: 15px;
            font-weight: 500;
            color: #111827;
            font-family: 'Inter', system-ui, sans-serif;
          }
        `}
      </style>

      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {enquiryData || student_id ? (
          <>
            {/* Header */}
            <div
              className="container-fluid p-0"
              style={{
                marginTop: window.innerWidth < 992 ? '55px' : '-12px',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
                <div 
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    background: '#F3F4F6',
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    overflow: 'visible',
                    borderBottom: '1px solid #D1D3D4',
                    width: '100%',
                  }}
                >
                  {/* Left: Title and Back Button */}
                  <div className="d-flex align-items-center gap-3">
                    {/* School Logo */}
                    <div style={{ 
                      width: '40px', 
                      height: '40px', 
                      borderRadius: '50%', 
                      overflow: 'hidden', 
                      background: '#223843',
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      flexShrink: 0,
                    }}>
                      {!logoError ? (
                        <img 
                          src={logo} 
                          alt="School Logo" 
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          onError={() => setLogoError(true)}
                        />
                      ) : (
                        <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                      )}
                    </div>
                    
                    <h3 
                      className="m-0 fw-bold" 
                      style={{ 
                        letterSpacing: '-0.02em',
                        overflow: 'visible',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: 'clamp(18px, 2.5vw, 22px)',
                        color: '#223843',
                        lineHeight: '1.2',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      Update{' '}
                      {formData.name
                        ? formData.name.charAt(0).toUpperCase() +
                          formData.name.slice(1).toLowerCase()
                        : 'Student'}'s Profile
                    </h3>
                  </div>
                  
                  {/* Right: Profile Icon with Dropdown */}
                  {!isMobile && (
                  <ProfileDropdown logout={logout} />
                  )}
                </div>
              </div>
            </div>

            <Container 
              className="mt-4"
              style={{
                paddingLeft: isCollapsed ? '32px' : '40px',
                paddingRight: '32px',
                paddingTop: '32px',
                paddingBottom: '32px',
              }}
            >
              {/* Profile Summary Section */}
              <Row className="mb-4">
                <Col xs={12} md={8}>
                  <Card 
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      height: '100%',
                    }}
                  >
                    <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                      {/* Profile Photo */}
                      <div className="mb-4" style={{ position: 'relative', display: 'inline-block' }}>
                        <label
                          htmlFor="studentImageInput"
                          style={{ cursor: 'pointer' }}
                        >
                          {formData.student_image || studentImage ? (
                            <div
                              style={{
                                width: '140px',
                                height: '140px',
                                borderRadius: '50%',
                                border: '4px solid #223843',
                                overflow: 'visible',
                                background: '#ffffff',
                                display: 'inline-block',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                position: 'relative',
                              }}
                            >
                              <img
                                src={
                                  studentImage
                                    ? URL.createObjectURL(studentImage)
                                    : formData.student_image
                                }
                                alt="Profile"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  borderRadius: '50%',
                                }}
                              />
                              {/* Back to List Button */}
                              <button
                                onClick={handleBack}
                                style={{
                                  position: 'absolute',
                                  bottom: '-8px',
                                  right: '-8px',
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '50%',
                                  backgroundColor: '#223843',
                                  border: '3px solid #ffffff',
                                  color: '#ffffff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                  zIndex: 10,
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#223843'
                                  e.currentTarget.style.transform = 'scale(1.1)'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = '#223843'
                                  e.currentTarget.style.transform = 'scale(1)'
                                }}
                                title="Back to Student list"
                              >
                                <FaArrowLeft size={16} />
                              </button>
                            </div>
                          ) : (
                            <div
                              style={{
                                width: '140px',
                                height: '140px',
                                borderRadius: '50%',
                                border: '4px solid #223843',
                                background: '#F3F4F6',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                position: 'relative',
                              }}
                            >
                              <FaUser size={64} style={{ color: '#9ca3af' }} />
                              {/* Back to List Button */}
                              <button
                                onClick={handleBack}
                                style={{
                                  position: 'absolute',
                                  bottom: '-8px',
                                  right: '-8px',
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '50%',
                                  backgroundColor: '#223843',
                                  border: '3px solid #ffffff',
                                  color: '#ffffff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                  zIndex: 10,
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#223843'
                                  e.currentTarget.style.transform = 'scale(1.1)'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = '#223843'
                                  e.currentTarget.style.transform = 'scale(1)'
                                }}
                                title="Back to Student List"
                              >
                                <FaArrowLeft size={16} />
                              </button>
                            </div>
                          )}
                        </label>
                        <input
                          type="file"
                          id="studentImageInput"
                          accept="image/*"
                          style={{ display: 'none' }}
                          onChange={(e) => {
                            const file = e.target.files[0]
                            if (file) {
                              if (file.size > 2 * 1024 * 1024) {
                                toast.error('Image size should not exceed 2MB.')
                                return
                              }
                              setStudentImage(file)
                            }
                          }}
                        />
                      </div>

                      {/* Student Name */}
                      <h2 className='text-uppercase'
                        style={{
                          color: '#111827',
                          fontWeight: '700',
                          fontSize: 'clamp(24px, 3vw, 32px)',
                          marginBottom: '12px',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {formData?.name
                          ? formData.name.charAt(0).toUpperCase() +
                            formData.name.slice(1).toLowerCase()
                          : 'N/A'}
                      </h2>

                      {/* Email/Admission Number */}
                      <div className="mb-4">
                        <p 
                          style={{
                            color: '#6b7280',
                            fontSize: '16px',
                            marginBottom: '8px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                          }}
                        >
                          <FaEnvelope size={16} />
                          {formData?.email || formData?.admission_number || 'N/A'}
                        </p>
                      </div>

                      {/* Status Badge */}
                      {formData?.status && (
                        <div className="d-flex flex-wrap justify-content-center gap-2">
                          <span
                            style={{
                              backgroundColor: formData?.status === 'active' ? '#ECFDF5' : '#FEE2E2',
                              color: formData?.status === 'active' ? '#10B981' : '#EF4444',
                              padding: '8px 16px',
                              borderRadius: '20px',
                              fontSize: '13px',
                              fontWeight: '600',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            {formData.status.charAt(0).toUpperCase() +
                              formData.status.slice(1)}
                          </span>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>

                {/* Save Button Card (Right) */}
                <Col xs={12} md={4}>
                  <Card 
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      background: 'linear-gradient(135deg, #F3F4F6 0%, #ffffff 100%)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: isMobile ? '16px' : undefined,
                    }}
                  >
                    <Card.Body style={{ 
                      padding: '40px', 
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                    }}>
                      <div style={{ width: '100%' }}>
                        <div
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: '#EFF6FF',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '20px',
                          }}
                        >
                          <BsPencilFill size={40} style={{ color: '#223843' }} />
                        </div>
                        <h5
                          style={{
                            color: '#111827',
                            fontWeight: '600',
                            fontSize: '18px',
                            marginBottom: '12px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          Update Profile
                        </h5>
                        <p
                          style={{
                            color: '#6b7280',
                            fontSize: '14px',
                            marginBottom: '24px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          Save changes to student information
                        </p>
                        <Button
                          onClick={handleSaveAsStudent}
                          className="w-100"
                          style={{
                            backgroundColor: '#223843',
                            border: 'none',
                            color: '#ffffff',
                            borderRadius: '12px',
                            padding: '14px 28px',
                            fontWeight: '600',
                            fontSize: '16px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'translateY(-2px)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'translateY(0)'
                          }}
                        >
                          <BsPencilFill /> Save Changes
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* Personal Information Section */}
              <Row className="mb-4">
                <Col xs={12}>
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                    }}
                  >
                    {/* Header with Icon */}
                    <div
                      style={{
                        background: 'linear-gradient(135deg, #223843 0%, #223843 100%)',
                        padding: '16px 24px',
                        borderBottom: '1px solid #D1D3D4',
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '10px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backdropFilter: 'blur(10px)',
                            }}
                          >
                            <FaUser size={18} style={{ color: '#ffffff' }} />
                          </div>
                          <div>
                            <h5 className='text-start'
                              style={{
                                margin: 0,
                                fontWeight: '700',
                                color: '#ffffff',
                                fontSize: '18px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Personal Information
                            </h5>
                            <p
                              style={{
                                margin: '2px 0 0 0',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: '12px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Update student details and contact information
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => setShowPersonalInfo(!showPersonalInfo)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title={showPersonalInfo ? "Hide Section" : "Show Section"}
                        >
                          {showPersonalInfo ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                        </button>
                      </div>
                    </div>

                    {showPersonalInfo && (
                      <Card.Body style={{ padding: '20px' }}>
                        <Row className="g-3 text-start">
                          {/* Left Column */}
                          <Col xs={12} md={6}>
                            {/* Admission Details Card */}
                            <div
                              style={{
                                backgroundColor: '#F9FAFB',
                                borderRadius: '12px',
                                padding: '14px',
                                border: '1px solid #E5E7EB',
                                marginBottom: '12px',
                              }}
                            >
                              <h6
                                style={{
                                  marginBottom: '10px',
                                  fontWeight: '600',
                                  color: '#223843',
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  fontFamily: 'Inter, system-ui, sans-serif',
                                }}
                              >
                                Admission Details
                              </h6>
                              <div className="d-flex flex-column gap-2">
                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaUser size={14} style={{ color: '#10B981' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Student Name</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.name || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        name: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <BsBuilding size={14} style={{ color: '#223843' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Institute Name</div>
                                  </div>
                                  <Form.Select
                                    className="form-control p-0 border-0"
                                    value={formData.institute_id || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        institute_id: e.target.value,
                                      })
                                    }
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                      padding: '0',
                                    }}
                                  >
                                    <option value="">Select Institute</option>
                                    {institutes.map((inst) => (
                                      <option
                                        key={inst.institute_id}
                                        value={inst.institute_id}
                                      >
                                        {inst.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <BsPersonBadge size={14} style={{ color: '#223843' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Admission Number</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.admission_number || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        admission_number: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                {/* <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaIdCard size={14} style={{ color: '#223843' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Roll Number</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.roll_number || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        roll_number: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                    placeholder="Enter Roll Number"
                                  />
                                </div> */}

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <BsCalendar3 size={14} style={{ color: '#223843' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Admission Date</div>
                                  </div>
                                  <Form.Control
                                    type="date"
                                    value={formData.admission_date || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        admission_date: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Personal Details Card */}
                            <div
                              style={{
                                backgroundColor: '#F9FAFB',
                                borderRadius: '12px',
                                padding: '14px',
                                border: '1px solid #E5E7EB',
                              }}
                            >
                              <h6
                                style={{
                                  marginBottom: '10px',
                                  fontWeight: '600',
                                  color: '#10B981',
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  fontFamily: 'Inter, system-ui, sans-serif',
                                }}
                              >
                                Personal Details
                              </h6>
                              <div className="d-flex flex-column gap-2">
                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <BsCalendar3 size={14} style={{ color: '#10B981' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Birth Date</div>
                                  </div>
                                  <Form.Control
                                    type="date"
                                    value={formData.dob || ''}
                                    onChange={(e) =>
                                      setFormData({ ...formData, dob: e.target.value })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaUser size={14} style={{ color: '#10B981' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Age</div>
                                  </div>
                                  <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                                    {calculateAge(formData?.dob) || 'N/A'} years
                                  </div>
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaVenusMars size={14} style={{ color: '#10B981' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Gender</div>
                                  </div>
                                  <Form.Select
                                    className="form-control p-0 border-0"
                                    value={formData.gender || ''}
                                    onChange={(e) =>
                                      setFormData({ ...formData, gender: e.target.value })
                                    }
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                      padding: '0',
                                    }}
                                  >
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                  </Form.Select>
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* Right Column */}
                          <Col xs={12} md={6}>
                            {/* Contact Information Card */}
                            <div
                              style={{
                                backgroundColor: '#F9FAFB',
                                borderRadius: '12px',
                                padding: '14px',
                                border: '1px solid #E5E7EB',
                                marginBottom: '12px',
                              }}
                            >
                              <h6
                                style={{
                                  marginBottom: '10px',
                                  fontWeight: '600',
                                  color: '#F59E0B',
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  fontFamily: 'Inter, system-ui, sans-serif',
                                }}
                              >
                                Contact Information
                              </h6>
                              <div className="d-flex flex-column gap-2">
                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaEnvelope size={14} style={{ color: '#F59E0B' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Email Address</div>
                                  </div>
                                  <Form.Control
                                    type="email"
                                    value={formData.email || ''}
                                    onChange={(e) =>
                                      setFormData({ ...formData, email: e.target.value })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaPhone size={14} style={{ color: '#F59E0B' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Phone Number</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.phone || ''}
                                    onChange={(e) =>
                                      setFormData({ ...formData, phone: e.target.value })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaPhone size={14} style={{ color: '#F59E0B' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Parent's Number</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.parents_number || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        parents_number: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaPhone size={14} style={{ color: '#F59E0B' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>WhatsApp Number</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.whatsapp_number || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        whatsapp_number: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Additional Information Card */}
                            <div
                              style={{
                                backgroundColor: '#F9FAFB',
                                borderRadius: '12px',
                                padding: '14px',
                                border: '1px solid #E5E7EB',
                              }}
                            >
                              <h6
                                style={{
                                  marginBottom: '10px',
                                  fontWeight: '600',
                                  color: '#223843',
                                  fontSize: '12px',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  fontFamily: 'Inter, system-ui, sans-serif',
                                }}
                              >
                                Additional Information
                              </h6>
                              <div className="d-flex flex-column gap-2">
                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <FaMapMarkerAlt size={14} style={{ color: '#10B981' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Address</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.address || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        address: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    border: '1px solid #E5E7EB',
                                  }}
                                >
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <BsFileEarmarkText size={14} style={{ color: '#223843' }} />
                                    <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>ID Proof Number</div>
                                  </div>
                                  <Form.Control
                                    type="text"
                                    value={formData.id_proof_number || ''}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        id_proof_number: e.target.value,
                                      })
                                    }
                                    className="border-0 p-0"
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#111827',
                                    }}
                                  />
                                </div>

                                {formData?.status && (
                                  <div
                                    style={{
                                      backgroundColor: '#ffffff',
                                      borderRadius: '8px',
                                      padding: '8px 12px',
                                      border: '1px solid #E5E7EB',
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <BsPersonBadge size={14} style={{ color: '#223843' }} />
                                      <div className="info-label" style={{ marginBottom: 0, fontSize: '11px' }}>Status</div>
                                    </div>
                                    <div className="info-value" style={{ fontSize: '14px', fontWeight: '600', color: formData?.status === 'active' ? '#10B981' : '#EF4444' }}>
                                      {formData.status.charAt(0).toUpperCase() +
                                        formData.status.slice(1).toLowerCase()}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    )}
                  </Card>
                </Col>
              </Row>

              {/* Parent Information Section */}
              <Row className="mb-4">
                <Col xs={12}>
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                    }}
                  >
                    {/* Header with Icon */}
                    <div
                      style={{
                        background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
                        padding: '16px 24px',
                        borderBottom: '1px solid #D1D3D4',
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '10px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backdropFilter: 'blur(10px)',
                            }}
                          >
                            <FaUsers size={18} style={{ color: '#ffffff' }} />
                          </div>
                          <div>
                            <h5
                              style={{
                                margin: 0,
                                fontWeight: '700',
                                color: '#ffffff',
                                fontSize: '18px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Parent Information
                            </h5>
                            <p className='text-start'
                              style={{
                                margin: '2px 0 0 0',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: '12px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                            >
                              Update parent and guardian details
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => setShowParentInfo(!showParentInfo)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title={showParentInfo ? "Hide Section" : "Show Section"}
                        >
                          {showParentInfo ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                        </button>
                      </div>
                    </div>

                    {showParentInfo && (
                      <Card.Body style={{ padding: '20px' }}>
                        <Row className="g-3 text-start">
                          <Col xs={12} md={6}>
                            <div
                              style={{
                                backgroundColor: '#F9FAFB',
                                borderRadius: '12px',
                                padding: '14px',
                                border: '1px solid #E5E7EB',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <div
                                    style={{
                                      width: '36px',
                                      height: '36px',
                                      borderRadius: '8px',
                                      backgroundColor: '#F3E8FF',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <FaUsers size={16} style={{ color: '#9333EA' }} />
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <div className="info-label" style={{ marginBottom: '2px', fontSize: '11px' }}>Father's Name</div>
                                    <Form.Control
                                      type="text"
                                      value={formData.father_name || ''}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          father_name: e.target.value,
                                        })
                                      }
                                      className="border-0 p-0"
                                      style={{
                                        fontSize: '15px',
                                        fontWeight: '700',
                                        color: '#111827',
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col xs={12} md={6}>
                            <div
                              style={{
                                backgroundColor: '#F9FAFB',
                                borderRadius: '12px',
                                padding: '14px',
                                border: '1px solid #E5E7EB',
                                height: '100%',
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '12px',
                                  border: '1px solid #E5E7EB',
                                }}
                              >
                                <div className="d-flex align-items-center gap-2 mb-1">
                                  <div
                                    style={{
                                      width: '36px',
                                      height: '36px',
                                      borderRadius: '8px',
                                      backgroundColor: '#F3E8FF',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <FaUsers size={16} style={{ color: '#9333EA' }} />
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <div className="info-label" style={{ marginBottom: '2px', fontSize: '11px' }}>Mother's Name</div>
                                    <Form.Control
                                      type="text"
                                      value={formData.mother_name || ''}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          mother_name: e.target.value,
                                        })
                                      }
                                      className="border-0 p-0"
                                      style={{
                                        fontSize: '15px',
                                        fontWeight: '700',
                                        color: '#111827',
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    )}
                  </Card>
                </Col>
              </Row>
            </Container>
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <p style={{ color: '#6b7280', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
              Loading student data...
            </p>
          </div>
        )}
      </div>
    </>
  )
}

export default UpdateStudentProfile
